const styles = (theme) => ({
	container: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		gap: 1,
	},
	paper: {
		width: "100%",
		backgroundColor: theme.palette.background.paper,
		borderRadius: "16px",
		overflow: "hidden",
	},
	barraFiltro: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		gap: 1,
		marginBottom: "8px",
	},
	buscaField: {
		width: "260px",
		"@media (max-width: 600px)": {
			width: "100%",
		},
	},
	statusField: {
		width: "220px",
		"@media (max-width: 600px)": {
			width: "100%",
		},
	},
	botaoAtualizarTodos: {
		whiteSpace: "nowrap",
		marginLeft: "auto",
	},
	gridContainer: {
		width: "100%",
		height: "600px",
		overflow: "auto",
	},
	chip: {
		fontWeight: 600,
		height: "20px",
	},
	limparBusca: {
		cursor: "pointer",
	},
	skeletonContainer: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		gap: 0.5,
	},
	skeletonHeader: {
		borderRadius: "8px",
	},
	skeletonRow: {
		borderRadius: "4px",
	},
});

export default styles;
